module.exports = __webpack_public_path__ + "static/media/forest-ranges.1bc59720.png";